// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip-module_tooltip_14D7M"};